import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import { ElOption, ElSelect } from 'element-plus'

// eslint-disable-next-line no-undef
interface CandidateSelectOption {
  label: string
  value: string | number | boolean
  disabled?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'CandidateSelect',
  props: {
    modelValue: { type: [String, Number, Boolean], default: '' },
    options: { default: () => [] },
    placeholder: { default: '请选择' },
    disabled: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit

function updateValue(value: string | number | boolean) {
  emit('update:modelValue', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElSelect), _mergeProps({
    class: ["candidate-select", {
      'is-filled': _ctx.modelValue !== '' && _ctx.modelValue !== null && _ctx.modelValue !== undefined,
    }],
    "model-value": _ctx.modelValue,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    filterable: _ctx.filterable,
    clearable: _ctx.clearable
  }, _ctx.$attrs, {
    "popper-class": ['candidate-select-popper', _ctx.$attrs['popper-class']],
    "onUpdate:modelValue": updateValue,
    onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('change', $event)))
  }), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createBlock(_unref(ElOption), {
          key: String(option.value),
          label: option.label,
          value: option.value,
          disabled: option.disabled
        }, null, 8, ["label", "value", "disabled"]))
      }), 128))
    ]),
    _: 1
  }, 16, ["class", "model-value", "placeholder", "disabled", "filterable", "clearable", "popper-class"]))
}
}

})